
 

import { useState, useEffect, useRef } from "react"; 
import Container from "@mui/material/Container";
import MKTypography from "components/MKTypography"; 
import MKButton from "components/MKButton";
import MKBox from "components/MKBox";
import MKInput from "components/MKInput";
import Dropdowns from "components/AppKey/Dropdowns";
import Tooltip from "@mui/material/Tooltip"; 
import Icon from "@mui/material/Icon";
import logo from 'assets/images/appkey-red-circle-100.png';
import Grid from "@mui/material/Grid";
import Stack from "@mui/material/Stack";
import { v4 as uuidv4 } from "uuid"; 
import {QRCodeSVG} from 'qrcode.react';
import toImg from 'react-svg-to-image';
import { appAuth } from "../../contexts/AppContext"

export default function AppActionQRDetail({qr, action, onSubmit, onClose }) { 
   
    const [actionQRData, setActionQRData] = useState(qr ? qr : {})
    const [isUpdated, isSetUpdated] = useState(false)
    const [qrParams, setQRParams] = useState(qr ? qr.params : [])
    const {qrWebUrl} = appAuth()
    const [locale, setLocale] = useState("EN")
    
    const qrLink = `${qrWebUrl}/qr${qr ? "/"+qr.qrId : "" }`
    const onChangeValue = (evt)=> {

        setActionQRData({
            ...actionQRData,
            [evt.target.name]: evt.target.value
        })

        isSetUpdated(true)
    } 

    const onChangeKeyValue = (evt)=> {
        let nameParts = evt.target.name.split("-")
        let key = nameParts[0]
        let index = nameParts[1]

        let newQRParams = qrParams.map((item, i) => {
            if(i == index) {
                return {
                    ...item,
                    [key]: evt.target.value,
                   // ['isEmpty']: evt.target.value ? false : true
                }
            } 
            return item
        })

        setQRParams(newQRParams)

        setActionQRData({
            ...actionQRData,
            ['params']: newQRParams
        }) 
        isSetUpdated(true)
    }

    const checkEmptyParams = () => {
        let empty = false
        qrParams.map((item, i) => {
            if(!item.key || !item.value) empty = true
        })

        return empty
    }

    const updateActionHandler = async () => {
        if(!isUpdated) {
            onClose()
            return;
        }

        if(!actionQRData.name) {
            alert("Please enter all fields")
            return;
        }

        if(checkEmptyParams()) {
            alert("Please remove empty params or fill in all fields")
            return;
        }

        setActionQRData({
            ...actionQRData,
            ['params']: qrParams
        }) 
        console.log("updateActionHandler ", actionQRData);
        
        onSubmit(actionQRData)
        
    }

    const handleCloseButton = () => {
        if(isUpdated) {
            if(window.confirm("You have unsaved changes. Are you sure to leave?")) {
                onClose()
            }
        } else  onClose()
    }

    const makeRandomString = () => {
        // let result           = "";
        // let characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        // let charactersLength = characters.length;
        // for ( let i = 0; i < 10; i++ ) {
        //     result += characters.charAt(Math.floor(Math.random() * charactersLength));
        // }

        setActionQRData({
            ...actionQRData,
            device: uuidv4()
        })
        isSetUpdated(true)
        console.log("makeRandomString ", actionQRData)
    }

    const checkEmptyValue = (value) => {
        return value ? false : true
    }   

    const addQRParam = () => {
        let element = { key: "", value: "" } 
       
        setActionQRData({
            ...actionQRData,
            ['params']: qrParams.concat(element)
        }) 

        setQRParams(prevItems => { 
            return [...prevItems, element];
        }); 

    }

    const copyQRImage = async () => {
        const svg = document.querySelector('svg');
        if(!svg) return;
        try { 
            let filename = actionQRData.name ? actionQRData.name : actionQRData.qrId
            filename = filename.replace(/[^a-z0-9]/gi, '_').toLowerCase();
            
            const image = await toImg('svg', filename, { download: false, format: 'png' }).then( dataUrl => {
                // Convert dataURL to Blob
                const res = fetch(dataUrl);
                return res.then(resolved => resolved.blob());
            });

            console.log("image ", image)
            await navigator.clipboard.write([
                new ClipboardItem({
                    [image.type]: image
                })
            ]);
            alert("QR code copied to clipboard")
        } catch (err) {
            console.error(err.name, err.message);
            alert('Failed to copy qr image. This broswer does not allow to copy to clipboard. Please use download button instead.');
        }
        
    }

    const downloadQRImage = async () => {
        const svg = document.querySelector('svg');
        if(!svg) return;

        try { 
            let filename = actionQRData.name ? actionQRData.name : actionQRData.qrId
            filename = filename.replace(/[^a-z0-9]/gi, '_').toLowerCase();
           
            const image = await toImg('svg', filename)
           
            // const url = URL.createObjectURL(image);
            // const link = document.createElement('a');
            // link.href = url; 
            // link.click();
           
        } catch (err) {
            console.error(err.name, err.message);
            //alert("Failed to download")
        }
    }

    const removeQRParams = (index) => {
       

        setActionQRData({
            ...actionQRData,
            ['params']: qrParams.filter((item, i) => i !== index)
        }) 

        setQRParams( prevItems => prevItems.filter((item, i) => i !== index) );

        isSetUpdated(true)
    }


    return(

            <MKBox p={2} width={{ xs: "90vw", lg: "80vw" }} maxHeight= "90vh" overflow="auto" >
               <MKBox display="flex" justifyContent="space-between"> 
    
                    <Tooltip title="go back" placement="top">
                        <MKButton variant="outlined" color="info" onClick={() =>  handleCloseButton() }  p={2} iconOnly> <Icon sx={{ mr: 1 }}>arrow_back</Icon> </MKButton>
                    </Tooltip>
                    <MKBox justifyContent={"center"} alignItems="center" textAlign="center" >
                        <MKTypography variant="body" > Action QR Detail </MKTypography>
                        <MKTypography variant="h4" >
                            {actionQRData.name}
                        </MKTypography> 
                    </MKBox>
                   
    
                    <MKButton variant="gradient" color="primary" onClick={updateActionHandler} > Save </MKButton> 
    
                </MKBox>
    
                <Container>

                    <Grid container spacing={3} mt={2}  pb={5}>
                        <Grid item xs={12} md={5} lg={5}>
                            <Stack spacing={3}>
    
                                <MKBox component="section" display="flex">  
                                    <MKInput variant="standard" label="QR ID" disabled value={actionQRData.qrId}  /> 
                                    
                                    <MKButton color="white" onClick={() => {navigator.clipboard.writeText(actionQRData.qrId)}}>
                                        <Icon fontSize="large">copy</Icon>
                                    </MKButton>
                                    
                                </MKBox>
                                
                                <MKInput variant="standard" inputProps={{ maxLength: 50 }} label="QR Name" id="name" name='name' defaultValue={actionQRData.name} onChange={onChangeValue} required fullWidth  />
                                
                                <MKBox component="section" display="flex" spacing={2}>  
                                    <MKInput variant="standard" inputProps={{ maxLength: 50 }} label="Device" id="device" name='device' defaultValue={actionQRData.device} value={actionQRData.device} onChange={onChangeValue} fullWidth  /> 
                                    <MKButton variant="text" color="primary" onClick={makeRandomString} > UUID </MKButton> 
                                </MKBox>

                                <MKBox component="section" display="flex">  
                                    <MKTypography variant="body" > Params  </MKTypography>  
                                    <MKButton color="white" onClick={addQRParam}>
                                        <Icon fontSize="large">add</Icon>
                                    </MKButton> 
                                </MKBox>

                                {qrParams.map(function(item, index){ 
                                    return(
                                        <Stack direction="row" spacing={2} key={index}>
                                            <MKInput error={checkEmptyValue(item.key) } variant="standard" label="Key" id={"key-"+index} name={"key-"+index} defaultValue={item.key}  fullWidth onChange={onChangeKeyValue}  /> 
                                            <MKInput error={checkEmptyValue(item.value)} variant="standard" label="Value" id={"value-"+index} name={"value-"+index} defaultValue={item.value}  fullWidth  onChange={onChangeKeyValue}/> 
                                            <MKButton  variant="text" color="error" onClick={ () => removeQRParams(index)} iconOnly px={2}><Icon>delete</Icon></MKButton> &nbsp;
                                        </Stack>
                                    )
                                })
                                }
                            </Stack>
                        </Grid>

                        <Grid item xs={12} md={2} lg={2}> </Grid>

                        <Grid item xs={12} md={5} justifyContent={"right"} alignItems="right" textAlign="right" lg={5}>
                        
                            <Stack direction="row" spacing={2} mb={2} justifyContent="right">
                                
                                {/* <MKBox alignItems="center" justifyContent="left" display="flex" >
                                    <MKTypography variant="h6" color="text">
                                    QR Size
                                    </MKTypography>

                                    <Dropdowns items={["250", "500", "1000"]} defaultValue = { "250" } onChange={(val) => { 
                                        document.querySelector('svg').setAttribute("width", val)
                                    }} />

                                </MKBox> */}
                                <Tooltip title="copy to clipboard" placement="top">
                                    <MKButton variant="outlined" color="info" px={2} iconOnly onClick={copyQRImage}> <Icon sx={{ mr: 1 }}>copy_content</Icon> </MKButton>
                                </Tooltip>
                                <Tooltip title="download qr image" placement="top">
                                    <MKButton variant="outlined" color="info" px={2} iconOnly onClick={downloadQRImage}> <Icon sx={{ mr: 1 }}>file_download</Icon> </MKButton>
                                </Tooltip>
                               
                               
                            </Stack>

                            <QRCodeSVG
                                value={qrLink}
                                title={actionQRData.name}
                                size={250}
                                bgColor={"#ffffff"}
                                fgColor={"#000000"}
                                level={"L"}
                                imageSettings={{
                                    src: logo,
                                    x: undefined,
                                    y: undefined,
                                    height: 50,
                                    width: 50,
                                    opacity: 1,
                                    excavate: false,
                                }}
                            />
                            <MKBox justifyContent={"right"} alignItems="right" textAlign="right" >

                                <MKTypography variant="button" color="info" fontWeight="light"
                                component="a"
                                href= {qrLink}
                                target = "blank"
                                >
                                    {qrLink}
                                </MKTypography>
                            </MKBox>
                           

                        </Grid>

                    </Grid>

                </Container>

            </MKBox>

    )
}
